module.exports = __webpack_public_path__ + "static/img/logo-sinqia.0662c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-sinqia.png
// module id = kIVF
// module chunks = 1